import { useState } from "react";
import type { LocalStore } from "@onchainreps/storage";
import { BotGame } from "./BotGame";
import { MistakeTrainer } from "./MistakeTrainer";
import { OpeningsTrainer } from "./OpeningsTrainer";
import { TacticsTrainer } from "./TacticsTrainer";

type TrainerMode = "openings" | "tactics" | "mistakes" | "play";

interface TrainerHomeProps {
  store: LocalStore | null;
}

export function TrainerHome({ store }: TrainerHomeProps) {
  const [mode, setMode] = useState<TrainerMode>("openings");

  return (
    <div className="trainer">
      <div className="segmented segmented--wide" role="tablist">
        {(
          [
            ["openings", "Openings"],
            ["tactics", "Tactics"],
            ["mistakes", "Mistakes"],
            ["play", "Play"],
          ] as Array<[TrainerMode, string]>
        ).map(([id, label]) => (
          <button
            key={id}
            role="tab"
            aria-selected={mode === id}
            onClick={() => setMode(id)}
          >
            {label}
          </button>
        ))}
      </div>

      {mode === "openings" ? <OpeningsTrainer store={store} /> : null}
      {mode === "tactics" ? <TacticsTrainer store={store} /> : null}
      {mode === "mistakes" ? <MistakeTrainer store={store} /> : null}
      {mode === "play" ? <BotGame store={store} /> : null}
    </div>
  );
}
